import { render, staticRenderFns } from "./Bombas.vue?vue&type=template&id=8fb84506&scoped=true&"
import script from "./Bombas.vue?vue&type=script&lang=js&"
export * from "./Bombas.vue?vue&type=script&lang=js&"
import style0 from "./Bombas.vue?vue&type=style&index=0&id=8fb84506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb84506",
  null
  
)

export default component.exports